import { render, staticRenderFns } from "./SysCategoryList.vue?vue&type=template&id=3dfd4618&scoped=true&"
import script from "./SysCategoryList.vue?vue&type=script&lang=js&"
export * from "./SysCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd4618",
  null
  
)

export default component.exports